module.exports = __webpack_public_path__ + "static/img/bottom-1.09f4b9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter/bottom-1.png
// module id = SUWV
// module chunks = 1